/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type CareGiverAddedJournalEvent from "parog-web/models/care-giver-added-journal-event";
import type Patient from "parog-web/models/patient";
import type SemeiaSessionService from "parog-web/services/session";

import styles from "./index.module.css";

interface Signature {
  Args: {
    medic?: unknown;
    patient: Patient;
    careGivers: CareGiverAddedJournalEvent[];
  };
}

export default class CareGiversSectionContentComponent extends Component<Signature> {
  styles = styles;

  @service declare session: SemeiaSessionService;
  @service declare store: Store;
  @tracked saving = false;

  get careGivers() {
    return (
      this.args.careGivers || this.args.patient.careGiverAddedJournalEvents
    );
  }

  get selectedAlloLabo(): string {
    return (
      this.args.patient.referentLabUpdatedJournalEvent
        ?.careGiverAddedJournalEvent?.id || "none"
    );
  }

  get alloLaboCareGiversWithPhone(): CareGiverAddedJournalEvent[] {
    return this.careGivers.filter(
      careGiver =>
        careGiver.role == "analistique-laboratory" && Boolean(careGiver.phone)
    );
  }

  @action
  async changeReferentLab(id: string): Promise<void> {
    this.saving = true;

    if (id == "none" && this.args.patient.referentLabUpdatedJournalEvent) {
      await this.args.patient.referentLabUpdatedJournalEvent?.archive();
      this.args.patient.referentLabUpdatedJournalEvent?.unloadRecord();
    } else {
      const referentLabUpdatedJournalEvent =
        this.args.patient.referentLabUpdatedJournalEvent ||
        this.store.createRecord("referent-lab-updated-journal-event", {
          patient: this.args.patient,
          occurredAt: new Date()
        });

      referentLabUpdatedJournalEvent.careGiverAddedJournalEvent =
        this.store.peekRecord(
          "care-giver-added-journal-event",
          id
        ) as CareGiverAddedJournalEvent;
      await referentLabUpdatedJournalEvent.save();
    }
    this.saving = false;
  }
}
